import { api } from '@general/ui-kit'

// Everything the calendar asks: /calendar — its own API — plus the platform's
// /references for the record picker. No module's API is called from here.

const BASE = '/calendar'
const clean = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
)
const withScope = ({ scope, occurrence } = {}) => clean({ scope, occurrence })

export const calendarApi = {
  me: () => api.get(`${BASE}/me`),
  list: params => api.get(`${BASE}/events`, { params: clean(params) }),
  get: (id, occurrence) => api.get(`${BASE}/events/${id}`, { params: clean({ occurrence }) }),
  create: body => api.post(`${BASE}/events`, body),
  update: (id, body, scope) => api.patch(`${BASE}/events/${id}`, body, { params: withScope(scope) }),
  cancel: (id, body = {}) => api.post(`${BASE}/events/${id}/cancel`, body),
  remove: id => api.delete(`${BASE}/events/${id}`),
  respond: (id, body) => api.post(`${BASE}/events/${id}/respond`, body),
  setReminders: (id, reminders) => api.put(`${BASE}/events/${id}/reminders`, { reminders }),
  meeting: id => api.get(`${BASE}/events/${id}/meeting`),
  downloadIcs: id => api.download(`${BASE}/events/${id}/ics`),

  availability: params => api.get(`${BASE}/availability`, { params: clean(params) }),
  people: search => api.get(`${BASE}/people`, { params: clean({ search }) }),

  calendars: () => api.get(`${BASE}/calendars`),
  createCalendar: body => api.post(`${BASE}/calendars`, body),
  updateCalendar: (id, body) => api.patch(`${BASE}/calendars/${id}`, body),
  removeCalendar: id => api.delete(`${BASE}/calendars/${id}`),

  // A model answering takes longer than the 30 s every other call waits.
  draft: body => api.post(`${BASE}/ai/draft`, body, { timeout: 60_000 }),

  referenceTypes: () => api.get('/references'),
}
